import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { SchoolData } from '@k12/models';

const DATE_FORMAT_MM_DD_YYYY = 'MM/DD/YYYY';

const HDMA_DATE_FORMAT = {
  parse: {
    dateInput: DATE_FORMAT_MM_DD_YYYY
  },
  display: {
    dateInput: DATE_FORMAT_MM_DD_YYYY,
    monthYearLabel: DATE_FORMAT_MM_DD_YYYY
  }
};

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-hdma-information',
  standalone: true,
  imports: [ReactiveFormsModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, NgxMaskDirective],
  providers: [
    provideNgxMask(),
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: HDMA_DATE_FORMAT }
  ],
  templateUrl: './hdma-information.component.html'
})
export class HdmaInformationComponent {
  @Input() formGroup!: FormGroup;
  @Input() schoolData: SchoolData;

  protected readonly maxDate = new Date();

  get hdmaFirstName(): string {
    return this.schoolData.hdmaName?.split(' ')[0] || '';
  }

  get hdmaLastName(): string {
    return this.schoolData.hdmaName?.split(' ').slice(1).join(' ') || '';
  }

  onExtensionInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replaceAll(/\D/g, '').slice(0, 4);
    this.formGroup.get('schoolPhoneExt')?.setValue(input.value, { emitEvent: false });
  }
}
